module.exports = __webpack_public_path__ + "img/flag-blue.b530a1f1.svg";